<div class="tp-card" [ngClass]="deviceClass">
    <div *ngIf="text" class="extra-text mb-10" [innerHTML]="text"></div>
    <div id="tp-widget-wrapper" class="tp-widget-wrapper visible">
        <div id="trust-score" class="tp-widget-trustscore" *ngIf="!!label">{{ label }}</div>
        <div id="tp-widget-stars" class="tp-widget-stars">
            <div class="tp-stars">
                <div class="tp-stars-box" *ngIf="isDesktop">
                    <img [attr.src]="'assets/images/star-white.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star-white.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star-white.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star-white.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star-white.svg'" width="23" height="23" class="img-responsive">
                </div>
                <div class="tp-stars-box" *ngIf="!isDesktop">
                    <img [attr.src]="'assets/images/star.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star.svg'" width="23" height="23" class="img-responsive">
                    <img [attr.src]="'assets/images/star.svg'" width="23" height="23" class="img-responsive">
                </div>
            </div>
        </div>
        <!-- <p class="tp-stars-label">on TrustPilot</p> -->
    </div>
</div>